export default "<p>\n  button-rsvn works!\n</p>\n"